import {  ComboVariant, ProductVariant, ProductVariant2 } from "@/models/Product";

export function transformProductVariants(newList: ProductVariant2[]): ProductVariant[] {
    return newList.map(item => ({
        id: String(item.id),

        attribute_value: (item.attribute_value || []).map(attr => ({
            name: attr.name,
            attribute: {
                name: attr.attribute?.name || '',
                id: attr.attribute?.id
            }
        })),

        inventory_set: (item.vendor_quotes || []).map(quote => ({
            price: quote.price,
            discount: quote.discount,
            vendor: {
                id: String(quote.vendor.id),
                companyName: quote.vendor.company_name
            },
            c_id: quote.c_id
        })),

        insuranceData: {
            hasInsurance: item.insurance_data?.has_insurance ?? false,
            label: item.insurance_data?.label ?? ''
        },

        active_discount: item.active_discount ?? null,

        product: item.product ? {
            id: String(item.product.id),
            name: item.product.name,
            image_url: item.product.image_url || null,
            description: item.product.description || "",
            brand: {
                id: String(item.product.brand?.id),
                name: item.product.brand?.name || ""
            },
            category: {
                id: String(item.product.category?.id),
                name: item.product.category?.name || "",
                appDisplayName: item.product.category?.appDisplayName || item.product.category?.name || "",
            },
            insuranceData: null,
            slug: {
                slug: "",
                redirect_url: null
            },
            product_variants: []
        } : undefined
    }));
}


export function isNormalProduct(variant: ProductVariant|ComboVariant): boolean {
   return !('parent_type' in variant);
}

export function isComboProduct(variant: ProductVariant|ComboVariant): boolean {
   return 'parent_type' in variant;
}